import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { openPdfInTab } from "./printUtils";

pdfMake.vfs = pdfFonts.vfs;

const PrathanaReceiptPrint = (values, logoBase64, nakshatraMasterList, gotraMasterList, targetWindow = null) => {
    return new Promise((resolve, reject) => {
        try {
            const paymentTypes = {
                'CA': 'Cash',
                'CQ': 'Cheque',
                'DC': 'Credit/Debit Card',
                'RT': 'RTGS',
                'UP': 'UPI',
                'NB': 'Net Banking',
                'WL': 'Wallet',
                'Online': 'Online',
            }
            
            const {
                receiptNo = "NA",
                receiptDate,
                poojaType1,
                poojaDateTime1,
                devoteeName,
                mobile,
                gotra,
                nakshatra,
                prathanaAmount,
                prathanaRemarks,
                prathanaOther,
                paymentType,
                totalAmount,
                totalPerson,
            } = values || {};

            let formattedDate = '';
            if (receiptDate) {
                const receiptDateObj = new Date(receiptDate);
                if (!isNaN(receiptDateObj)) {
                    formattedDate = receiptDateObj.toLocaleDateString('en-GB').replace(/\//g, '-');
                }
            }

            const formatDate = (dateObj) =>
                dateObj ? new Date(dateObj).toLocaleDateString("en-IN", { day: '2-digit', month: 'short', year: 'numeric' }) : "";


            // Get gotra and nakshatra names
            const gotraName = gotraMasterList.find((g) => g.gotraId?.toString() === gotra?.toString())?.gotraName || "NA";
            const nakshatraName = nakshatraMasterList.find((n) => n.nakshatraId?.toString() === nakshatra?.toString())?.nakshatraName || "NA";


            const tableBody = [
                [
                    { text: "Sl.No.", bold: true },
                    { text: "Seva Name", bold: true },
                    { text: "Date", bold: true },
                    { text: "No.Of Persons", bold: true },
                    { text: "Rate", bold: true },
                    { text: "Amount", bold: true }
                ],
                [
                    { text: "1", alignment: 'center' },
                    { text: `Prathana Mandiara for ${prathanaRemarks || ''}` },
                    { text: formatDate(poojaDateTime1), alignment: 'center' },
                    { text: `${totalPerson}`, alignment: 'center' },
                    { text: "", alignment: 'center' },
                    { text: `₹${prathanaAmount}`, alignment: 'right' }
                ],
                [
                    { text: "2", alignment: 'center' },
                    { text: `Other Charges` },
                    { text: "", colSpan: 3, alignment: 'center' }, {}, {}, // merged Date, No.Of Persons, Rate
                    { text: `₹${prathanaOther}`, alignment: 'right' }
                ],
                [
                    { text: "", colSpan: 4 }, {}, {}, {},
                    { text: `Grand Total :`, bold: true, alignment: 'right' },
                    { text: `₹${totalAmount}`, bold: true, alignment: 'right' }
                ]
            ];


            const docDefinition = {
                content: [
                    {
                        columns: [
                            {
                                image: 'templeLogo',
                                width: 500,
                                alignment: 'center',
                                margin: [0, 0, 0, 10]
                            },
                        ]
                    },
                    {
                        stack: [
                            { text: "Sri VENUGOPALA SWAMY TEMPLE (R)", bold: true, fontSize: 14, margin: [0, 2] },
                            { text: "Sri Raghavendra Swamy Temple", bold: true, fontSize: 12, margin: [0, 2] },
                            { text: "Old Airport Road, Near Hal Market, Vimanapura, Bangalore-17", style: 'small' },
                            { text: "Secretary: 9448512003, President: 9480809048", style: 'small' },
                        ],
                        alignment: 'center',
                        margin: [0, 0, 0, 15]
                    },
                    {
                        columns: [
                            { text: `Receipt Date: ${formattedDate}`, alignment: 'left', margin: [0, 0, 0, 5] },
                            { text: `Receipt No.: ${receiptNo}`, alignment: 'right', margin: [0, 0, 0, 5] }
                        ]
                    },
                    {
                        columns: [
                            { text: `Devotee Name: ${devoteeName}`, margin: [0, 0, 0, 5] },
                            { text: `Mobile No.: ${mobile}`, alignment: 'right', margin: [0, 0, 0, 5] }
                        ]
                    },
                    {
                        columns: [
                            { text: `Prathana: ${formatDate(poojaDateTime1)}`, margin: [0, 0, 0, 5] },
                            { text: `Nakshatra Name: ${nakshatraName}`, alignment: 'center', margin: [0, 0, 0, 5] },
                            { text: `Gotra Name: ${gotraName}`, alignment: 'right', margin: [0, 0, 0, 5] }
                        ]
                    },
                    {
                        table: {
                            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
                            body: tableBody
                        },
                        layout: {
                            hLineWidth: function (i, node) {
                                return 0.5;
                            },
                            vLineWidth: function (i, node) {
                                return 0.5;
                            },
                            hLineColor: function (i, node) {
                                return '#444';
                            },
                            vLineColor: function (i, node) {
                                return '#444';
                            },
                            paddingLeft: function (i, node) { return 5; },
                            paddingRight: function (i, node) { return 5; },
                            paddingTop: function (i, node) { return 3; },
                            paddingBottom: function (i, node) { return 3; },
                        },
                        margin: [0, 0, 0, 15]
                    },
                    {
                        columns: [
                            { text: `Payment : ${paymentTypes[paymentType] || paymentType || 'NA'}`, margin: [0, 0, 0, 10] },
                            { text: `Total Persons: ${totalPerson}`, alignment: 'right', margin: [0, 0, 0, 10] }
                        ]
                    },
                    {
                        text: "Office Contact No - Srikanth Acharya : 9916077255, D S Suresh : 9448357701",
                        alignment: 'center',
                        style: 'small',
                        margin: [0, 0, 0, 0]
                    }
                ],
                images: {
                    templeLogo: logoBase64
                },
                styles: {
                    title: {
                        fontSize: 16,
                        bold: true,
                        alignment: 'center'
                    },
                    small: {
                        fontSize: 9,
                        lineHeight: 1.1
                    }
                },
                defaultStyle: {
                    fontSize: 10,
                    lineHeight: 1.2
                }
            };


            const pdfDoc = pdfMake.createPdf(docDefinition);
            openPdfInTab(pdfDoc, resolve, targetWindow);
        } catch (error) {
            console.error("Error in PrathanaReceiptPrint:", error);
            resolve({ success: false, error: error });
        }
    });
};

export default PrathanaReceiptPrint;
